/* ROYDED Superset builder.
   Mix any tops in any colours and sizes. Shopify automatic discounts take the saving off in the cart;
   this component shows the maths and adds the picks in one go.

   Openers: any element with data-rd-superset-open or data-rd3-open-superset (click is delegated on document).
     data-product-id   scroll to that product's card
     data-colour       show this colour for data-product-id without choosing a size
     data-variant-id   carry that variant into the stack on open
     data-quantity     how many of it (default 1). The stack holds at least this many, never double counts.
   Script: window.RDSupersetBuilder.open({ productId, variantId, quantity, opener }) and .close()

   Tops already in the cart count towards the tiers: the snippet seeds the count (data-cart-tops) and every open
   reads /cart.js again. Only lines of the builder's own products count, so a Full Stack line (its own product)
   never does. The stated saving and price are what the picks add on top of the cart's own saving.
   Those loose cart tops are also listed first in "Your stack" (one read only card per cart line, marked
   "In your cart"), then the new picks follow with their minus and plus. The stack count in its header is the
   cart tops plus the picks; the add button still adds only the picks.
   Each cart card can be edited here without going back to the cart: "Change" opens a colour and size picker that swaps
   one unit of that line (adds one of the new variant with the line's properties, then takes one off the old line),
   and the x takes one unit off. Both repaint the cart drawer sections and re-read the cart for the sheet. */
(function () {
  'use strict';

  if (window.RDSupersetBuilder && window.RDSupersetBuilder.version) {
    window.RDSupersetBuilder.scan(document);
    return;
  }

  var OPEN_SELECTOR = '[data-rd-superset-open],[data-rd3-open-superset]';
  var STORE_KEY = 'rd-superset:v1';
  var MAX_PER_SIZE = 20;
  var CART_SECTIONS = ['cart-drawer', 'cart-icon-bubble'];
  var PLUS = '<svg viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M2 6h8M6 2v8" stroke="currentColor" stroke-width="1.6" fill="none"/></svg>';
  var CROSS = '<svg viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M2.5 2.5l7 7M9.5 2.5l-7 7" stroke="currentColor" stroke-width="1.6" fill="none"/></svg>';
  var MINUS = '<svg viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M2 6h8" stroke="currentColor" stroke-width="1.6" fill="none"/></svg>';
  var phoneQuery = window.matchMedia('(max-width: 749px)');
  var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var instances = [];
  var lockDepth = 0;

  function reduced() { return motionQuery.matches; }

  function isPreviewTheme() {
    var theme = window.Shopify && window.Shopify.theme;
    return !!(theme && theme.role && theme.role !== 'main');
  }

  function money(cents) {
    var value = Math.round(Number(cents) || 0) / 100;
    var whole = Math.round(value) === value;
    return '$' + value.toLocaleString('en-NZ', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 });
  }

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function tops(n) { return n + (n === 1 ? ' top' : ' tops'); }

  // Adds a width to a Shopify CDN image url (used only when a cart line has no matching builder photo).
  function sized(url, width) {
    if (!url) return '';
    return String(url) + (String(url).indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function routeUrl(name, fallback) {
    var url = (window.routes && window.routes[name]) || fallback;
    return /\.js$/.test(url) ? url : url + '.js';
  }

  // fetch + JSON with a timeout, so a stalled request ends in a message instead of a hang.
  function request(url, options, timeout) {
    options = options || {};
    options.credentials = 'same-origin';
    var controller = window.AbortController ? new window.AbortController() : null;
    var timer = null;
    if (controller) {
      options.signal = controller.signal;
      timer = window.setTimeout(function () { controller.abort(); }, timeout || 10000);
    }
    var done = function () { if (timer) window.clearTimeout(timer); };
    return window.fetch(url, options).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (body) {
        if (!response.ok || (body && (body.status >= 400 || (body.errors && !body.items)))) throw body || {};
        return body;
      });
    }).then(function (body) { done(); return body; }, function (error) { done(); throw error; });
  }

  function post(url, body) {
    return request(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  }

  function cartErrorText(error) {
    if (error && error.name === 'AbortError') return 'That is taking too long. Try again.';
    var text = error && (error.description || error.message);
    if (typeof text === 'string' && text && !/^cart error$/i.test(text)) return text;
    return 'That did not go through. Your cart was refreshed, so check it and try again.';
  }

  // sections_url must be a real path (an embedded frame reports a bare name, which Shopify rejects).
  function sectionsPath() {
    var path = window.location.pathname || '/';
    return path.charAt(0) === '/' ? path : '/';
  }

  function sectionIds() {
    var ids = document.querySelector('cart-drawer') ? ['cart-drawer', 'cart-icon-bubble'] : ['cart-icon-bubble'];
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    if (items && items.dataset.id) ids.push(items.dataset.id);
    if (footer && footer.dataset.id) ids.push(footer.dataset.id);
    return ids;
  }

  function replaceSection(selector, html) {
    if (!html) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var target = document.querySelector(selector);
    var source = parsed.querySelector(selector) || parsed.querySelector('.shopify-section');
    if (target && source) target.innerHTML = source.innerHTML;
  }

  // Repaints the cart drawer (and the cart page, if that is where we are) from a cart payload that carries sections.
  function renderCartSections(payload) {
    var sections = payload && payload.sections;
    if (!sections) return false;
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    var itemsId = items && items.dataset.id;
    var footerId = footer && footer.dataset.id;
    if (sections['cart-drawer']) replaceSection('#CartDrawer', sections['cart-drawer']);
    if (sections['cart-icon-bubble']) replaceSection('#cart-icon-bubble', sections['cart-icon-bubble']);
    if (itemsId && sections[itemsId]) replaceSection('#main-cart-items .js-contents', sections[itemsId]);
    if (footerId && sections[footerId]) replaceSection('#main-cart-footer .js-contents', sections[footerId]);
    var count = typeof payload.item_count === 'number' ? payload.item_count : null;
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      if (count !== null) drawer.classList.toggle('is-empty', count === 0);
      var overlay = drawer.querySelector('#CartDrawer-Overlay');
      if (overlay && typeof drawer.close === 'function') overlay.addEventListener('click', drawer.close.bind(drawer));
    }
    if (footer && count !== null) footer.classList.toggle('is-empty', count === 0);
    try {
      if (typeof window.publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') window.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'rd-superset-builder', cartData: payload });
    } catch (e) { /* subscribers must never block the cart */ }
    try { if (window.RDCartUpsell && typeof window.RDCartUpsell.init === 'function') window.RDCartUpsell.init(); } catch (e) { /* offer cards come back on the next render */ }
    return true;
  }

  function parseTiers(raw) {
    return String(raw || '').split(',').map(function (pair) {
      var bits = pair.split(':');
      return { qty: parseInt(bits[0], 10), off: Math.round(parseFloat(bits[1]) * 100) };
    }).filter(function (tier) {
      return tier.qty > 0 && tier.off > 0;
    }).sort(function (a, b) { return a.qty - b.qty; });
  }

  function uuid() {
    try { if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID(); } catch (e) { /* fall through */ }
    return 'rdss-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  function restart(el, cls) {
    if (!el || reduced()) return;
    if (el.closest && el.closest('.rdss__dialog.is-calm')) return; // opening: no pops or flashes
    el.classList.remove(cls);
    void el.offsetWidth;
    el.classList.add(cls);
  }

  function lockScroll() {
    lockDepth += 1;
    if (lockDepth > 1) return;
    var doc = document.documentElement;
    var gap = window.innerWidth - doc.clientWidth;
    if (gap > 0) doc.style.setProperty('--rdss-gap', gap + 'px');
    doc.classList.add('rdss-lock');
  }

  function unlockScroll() {
    if (lockDepth === 0) return;
    lockDepth -= 1;
    if (lockDepth > 0) return;
    var doc = document.documentElement;
    doc.classList.remove('rdss-lock');
    doc.style.removeProperty('--rdss-gap');
  }

  function readStore() {
    try {
      var list = JSON.parse(window.sessionStorage.getItem(STORE_KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function writeStore(list) {
    try {
      if (list.length) window.sessionStorage.setItem(STORE_KEY, JSON.stringify(list));
      else window.sessionStorage.removeItem(STORE_KEY);
    } catch (e) { /* storage blocked: the builder still works for this page */ }
  }

  function Builder(root) {
    this.root = root;
    this.dialog = root.querySelector('[data-rdss-dialog]');
    this.panel = root.querySelector('[data-rdss-panel]');
    this.scrim = root.querySelector('[data-rdss-scrim]');
    this.scroller = root.querySelector('[data-rdss-body]');
    this.cardsEl = root.querySelector('[data-rdss-cards]');
    this.tiersEl = root.querySelector('[data-rdss-tiers]');
    this.lineEl = root.querySelector('[data-rdss-line]');
    this.strip = root.querySelector('[data-rdss-strip]');
    this.stackN = root.querySelector('[data-rdss-stack-n]');
    this.countEl = root.querySelector('[data-rdss-count]');
    this.wasEl = root.querySelector('[data-rdss-was]');
    this.nowEl = root.querySelector('[data-rdss-now]');
    this.saveEl = root.querySelector('[data-rdss-save]');
    this.cta = root.querySelector('[data-rdss-cta]');
    this.ctaLabel = root.querySelector('[data-rdss-cta-label]');
    this.ctaPrice = root.querySelector('[data-rdss-cta-price]');
    this.msg = root.querySelector('[data-rdss-msg]');
    this.live = root.querySelector('[data-rdss-live]');
    this.rail = root.querySelector('.rdss__rail');
    this.tiers = parseTiers(root.dataset.tiers); // amounts come only from the snippet's tiers param
    this.enabled = root.dataset.checkoutEnabled === 'true';
    this.cartTops = Math.max(0, parseInt(root.dataset.cartTops, 10) || 0);
    this.cartLines = []; // the loose tops in the cart, one entry per cart line (listed first in the stack)
    this.cartSig = '';
    this.cartItems = new Map(); // cart line key -> its card in the stack
    this.cartBusy = false; // a cart change from a card is in flight
    this.cartToken = 0;
    this.force = false;
    this.isOpen = false;
    this.busy = false;
    this.added = false;
    this.opener = null;
    this.primed = false;
    this.lastTier = -1;
    this.lineHtml = null;
    this.selection = new Map();
    this.variants = new Map();
    this.products = [];
    this.cards = new Map();
    this.trayItems = new Map();
    this.handlers = [];

    var data = { products: [] };
    try {
      var source = root.querySelector('[data-rdss-data]');
      if (source) data = JSON.parse(source.textContent);
    } catch (e) { /* malformed data renders an empty builder */ }

    this.index(data.products || []);
    this.buildRail();
    this.buildCards();
    this.restore();
    this.bind();
    this.watchCart();
    this.render({ quiet: true });
  }

  Builder.prototype.index = function (list) {
    var self = this;
    list.forEach(function (raw) {
      var product = { id: String(raw.id), title: raw.title || '', url: raw.url || '', colours: [], active: 0 };
      (raw.colours || []).forEach(function (rawColour, ci) {
        var colour = {
          index: ci,
          name: rawColour.name || '',
          plain: /^default$/i.test(rawColour.name || ''),
          img: rawColour.img || '',
          img2x: rawColour.img2x || '',
          thumb: rawColour.thumb || rawColour.img || '',
          alt: rawColour.alt || raw.title || '',
          variants: [],
          product: product
        };
        (rawColour.variants || []).forEach(function (rawVariant) {
          var variant = {
            id: String(rawVariant.id),
            size: String(rawVariant.size || ''),
            price: Number(rawVariant.price) || 0,
            available: rawVariant.available !== false,
            colour: colour,
            product: product
          };
          colour.variants.push(variant);
          self.variants.set(variant.id, variant);
        });
        if (colour.variants.length) product.colours.push(colour);
      });
      product.colours.forEach(function (colour, i) { colour.index = i; });
      var firstOpen = product.colours.findIndex(function (colour) {
        return colour.variants.some(function (variant) { return variant.available; });
      });
      product.active = firstOpen > -1 ? firstOpen : 0;
      if (product.colours.length) self.products.push(product);
    });
  };

  Builder.prototype.variantLabel = function (variant) {
    return (variant.colour.plain ? '' : variant.colour.name + ' ') + variant.size;
  };

  /* ---------- Build ---------- */

  Builder.prototype.buildRail = function () {
    if (!this.tiersEl) return;
    if (this.rail) this.rail.hidden = !this.tiers.length;
    this.tierEls = [];
    this.tickEls = [];
    this.fillEl = null;
    this.barMax = 0;
    if (!this.tiers.length) { this.tiersEl.innerHTML = ''; return; }
    // One continuous bar from 0 tops to the last tier, in equal steps: a tick at every top, a label at every tier.
    var last = this.tiers.length - 1;
    var max = this.tiers[last].qty;
    var tickAt = [];
    if (max <= 12) { for (var q = 1; q <= max; q++) tickAt.push(q); }
    else this.tiers.forEach(function (tier) { tickAt.push(tier.qty); });
    this.barMax = max;
    this.tiersEl.innerHTML = '<div class="rdss-bar__track" aria-hidden="true"><i class="rdss-bar__fill"></i>' +
      tickAt.map(function (q) { return '<i class="rdss-bar__tick" data-at="' + q + '" style="--at:' + (q / max) + '"></i>'; }).join('') +
      '</div><div class="rdss-bar__labels">' +
      this.tiers.map(function (tier, i) {
        return '<span class="rdss-bar__lab' + (i === last ? ' is-last' : '') + '" style="--at:' + (tier.qty / max) + '">' +
          '<span>' + tier.qty + (i === last ? '+' : '') + ' tops</span><span>' + money(tier.off) + ' off</span></span>';
      }).join('') + '</div>';
    this.fillEl = this.tiersEl.querySelector('.rdss-bar__fill');
    this.tickEls = Array.prototype.slice.call(this.tiersEl.querySelectorAll('.rdss-bar__tick'));
    this.tierEls = Array.prototype.slice.call(this.tiersEl.querySelectorAll('.rdss-bar__lab'));
  };

  Builder.prototype.buildCards = function () {
    var self = this;
    if (!this.cardsEl || !this.products.length) return;
    this.cardsEl.innerHTML = '';
    this.products.forEach(function (product, i) {
      var nameId = self.root.id + '-p' + product.id;
      var prices = [];
      product.colours.forEach(function (colour) { colour.variants.forEach(function (v) { prices.push(v.price); }); });
      var low = Math.min.apply(null, prices);
      var high = Math.max.apply(null, prices);
      var showColours = !(product.colours.length === 1 && product.colours[0].plain);
      var swatches = product.colours.map(function (colour) {
        return '<button type="button" class="rdss-swatch" data-swatch="' + colour.index + '" aria-pressed="false" aria-label="' + esc(colour.name) + '" title="' + esc(colour.name) + '">' +
          (colour.thumb ? '<img src="' + esc(colour.thumb) + '" alt="" width="52" height="52" loading="lazy" decoding="async">' : '') +
          '<span class="rdss-swatch__n" data-n aria-hidden="true" hidden></span></button>';
      }).join('');

      var card = document.createElement('article');
      card.className = 'rdss-card';
      card.tabIndex = -1;
      card.dataset.productId = product.id;
      card.style.setProperty('--i', i);
      card.setAttribute('aria-labelledby', nameId);
      // Wide drawer: the square photo on the left; name, price, colour and sizes stacked on the right.
      // Narrow drawer and phones: the wrappers dissolve (display: contents) and sizes run the full width.
      card.innerHTML =
        '<div class="rdss-card__side">' +
          '<a class="rdss-card__media" href="' + esc(product.url) + '" data-card-link tabindex="-1" aria-hidden="true">' +
            '<img class="rdss-card__img is-on" alt="" loading="lazy" decoding="async">' +
            '<img class="rdss-card__img" alt="" loading="lazy" decoding="async" aria-hidden="true">' +
            '<span class="rdss-card__tag" data-tag aria-hidden="true"></span>' +
            '<span class="rdss-card__count" data-count aria-hidden="true" hidden></span>' +
          '</a>' +
        '</div>' +
        '<div class="rdss-card__info">' +
          '<div class="rdss-card__head">' +
            '<h3 class="rdss-card__name" id="' + nameId + '"><a href="' + esc(product.url) + '" data-card-link>' + esc(product.title) + '</a></h3>' +
            '<p class="rdss-card__price">' + (low === high ? money(low) : money(low) + ' to ' + money(high)) + '</p>' +
          '</div>' +
          (showColours ?
            '<div class="rdss-card__group rdss-card__group--colour">' +
              '<div class="rdss-card__swatches" role="group" aria-label="Colour">' + swatches + '</div>' +
              '<p class="rdss-card__label"><b data-colour-name></b></p>' +
            '</div>' : '') +
          '<div class="rdss-card__group rdss-card__group--size">' +
            '<div class="rdss-card__sizes" role="group" aria-label="Size. Each tap adds one" data-sizes></div>' +
          '</div>' +
        '</div>';

      self.cardsEl.appendChild(card);
      self.cards.set(product.id, {
        el: card,
        imgs: Array.prototype.slice.call(card.querySelectorAll('.rdss-card__img')),
        tag: card.querySelector('[data-tag]'),
        count: card.querySelector('[data-count]'),
        colourName: card.querySelector('[data-colour-name]'),
        swatches: Array.prototype.slice.call(card.querySelectorAll('[data-swatch]')),
        sizes: card.querySelector('[data-sizes]'),
        links: Array.prototype.slice.call(card.querySelectorAll('[data-card-link]')),
        token: 0
      });
      self.showColour(product, product.active, false);
    });
  };

  Builder.prototype.setImage = function (img, product, colour) {
    if (!colour.img) { img.removeAttribute('src'); img.removeAttribute('srcset'); return; }
    if (colour.img2x) {
      img.srcset = colour.img + ' 600w, ' + colour.img2x + ' 1100w';
      img.sizes = phoneQuery.matches ? '44vw' : '300px';
    } else {
      img.removeAttribute('srcset');
    }
    img.src = colour.img;
  };

  Builder.prototype.showColour = function (product, index, animate) {
    var card = this.cards.get(product.id);
    var colour = product.colours[index];
    if (!card || !colour) return;
    product.active = index;

    var current = card.imgs.filter(function (img) { return img.classList.contains('is-on'); })[0] || card.imgs[0];
    var label = colour.alt || (product.title + ' in ' + colour.name);
    if (!animate || reduced() || !this.isOpen) {
      this.setImage(current, product, colour);
      current.alt = label;
    } else {
      var next = card.imgs.filter(function (img) { return img !== current; })[0];
      var token = ++card.token;
      this.setImage(next, product, colour);
      next.loading = 'eager';
      var swap = function () {
        if (token !== card.token) return;
        current.classList.remove('is-on');
        current.setAttribute('aria-hidden', 'true');
        current.alt = '';
        next.classList.add('is-on');
        next.removeAttribute('aria-hidden');
        next.alt = label;
      };
      if (typeof next.decode === 'function') next.decode().then(swap, swap);
      else swap();
    }

    // The name and photo open the product page in the colour on show (?colour=green-grey, as on the product cards)
    var href = product.url && !colour.plain ? product.url + '?colour=' + String(colour.name).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') : product.url;
    card.links.forEach(function (a) { if (href) a.setAttribute('href', href); });
    if (card.tag) card.tag.textContent = colour.plain ? '' : colour.name;
    if (card.colourName) card.colourName.textContent = colour.plain ? '' : colour.name;
    card.swatches.forEach(function (swatch) {
      swatch.setAttribute('aria-pressed', String(Number(swatch.dataset.swatch) === index));
    });
    this.buildSizes(product);
  };

  Builder.prototype.buildSizes = function (product) {
    var self = this;
    var card = this.cards.get(product.id);
    var colour = product.colours[product.active];
    card.sizes.innerHTML = colour.variants.map(function (variant) {
      var label = esc(self.variantLabel(variant));
      if (!variant.available) {
        return '<div class="rdss-size is-soldout" data-variant-id="' + variant.id + '">' +
          '<button type="button" class="rdss-size__add" disabled aria-label="' + label + ', sold out"><span class="rdss-size__label"><i aria-hidden="true">+</i>' + esc(variant.size) + '</span></button></div>';
      }
      return '<div class="rdss-size" data-variant-id="' + variant.id + '">' +
        '<button type="button" class="rdss-size__add" data-rdss-add="' + variant.id + '" data-rd-offer-interaction="size_selection">' +
          '<span class="rdss-size__label"><i aria-hidden="true">+</i>' + esc(variant.size) + '</span><span class="rdss-size__qty" aria-hidden="true"></span></button>' +
        '<button type="button" class="rdss-size__minus" data-rdss-minus="' + variant.id + '" aria-label="Remove one ' + label + '" tabindex="-1" aria-hidden="true">' + MINUS + '</button></div>';
    }).join('');
    this.paintCard(product, null);
  };

  /* ---------- State ---------- */

  Builder.prototype.restore = function () {
    var self = this;
    readStore().forEach(function (entry) {
      if (!Array.isArray(entry)) return;
      var variant = self.variants.get(String(entry[0]));
      var qty = Math.min(MAX_PER_SIZE, parseInt(entry[1], 10) || 0);
      if (variant && variant.available && qty > 0) self.selection.set(variant.id, qty);
    });
  };

  Builder.prototype.save = function () {
    writeStore(Array.from(this.selection.entries()));
  };

  Builder.prototype.tierOff = function (count) {
    var off = 0;
    this.tiers.forEach(function (t) { if (count >= t.qty) off = t.off; });
    return off;
  };

  // count, full, off and now are the picks; total, tier, next and totalOff also count the tops already in the cart.
  // total (cart tops + picks, counted once) drives the tiers, the rail and the stack count in the header.
  // off is only what the picks add to the cart's own saving, so nothing is counted twice.
  Builder.prototype.totals = function () {
    var self = this;
    var count = 0;
    var full = 0;
    this.selection.forEach(function (qty, id) {
      var variant = self.variants.get(id);
      if (!variant) return;
      count += qty;
      full += qty * variant.price;
    });
    var cart = this.cartTops || 0;
    var total = cart + count;
    var tier = -1;
    this.tiers.forEach(function (t, i) { if (total >= t.qty) tier = i; });
    var totalOff = tier > -1 ? this.tiers[tier].off : 0;
    var off = Math.min(Math.max(0, totalOff - this.tierOff(cart)), full);
    var next = this.tiers.filter(function (t) { return t.qty > total; })[0] || null;
    return { count: count, cart: cart, total: total, full: full, off: off, totalOff: totalOff, now: full - off, tier: tier, next: next };
  };

  Builder.prototype.add = function (id) {
    var variant = this.variants.get(String(id));
    if (!variant || !variant.available || this.busy || this.added) return;
    var qty = this.selection.get(variant.id) || 0;
    if (qty >= MAX_PER_SIZE) {
      this.showMsg(MAX_PER_SIZE + ' of one size is the max.', 'note');
      return;
    }
    this.selection.set(variant.id, qty + 1);
    this.changed({ variant: variant, delta: 1 });
  };

  // Carries a choice over from the page: hold at least `quantity` of it, never add on top of what is already there.
  Builder.prototype.carry = function (variant, quantity) {
    if (!variant || !variant.available || this.busy || this.added) return;
    var want = Math.max(1, Math.min(MAX_PER_SIZE, parseInt(quantity, 10) || 1));
    var have = this.selection.get(variant.id) || 0;
    if (have >= want) return;
    this.selection.set(variant.id, want);
    this.changed({ variant: variant, delta: want - have });
  };

  Builder.prototype.remove = function (id) {
    var variant = this.variants.get(String(id));
    var qty = this.selection.get(String(id)) || 0;
    if (!variant || !qty || this.busy || this.added) return;
    if (qty <= 1) this.selection.delete(variant.id);
    else this.selection.set(variant.id, qty - 1);
    this.changed({ variant: variant, delta: -1 });
  };

  Builder.prototype.changed = function (change) {
    this.clearMsg();
    this.save();
    this.render({ change: change });
  };

  /* ---------- Paint ---------- */

  Builder.prototype.render = function (opts) {
    opts = opts || {};
    var self = this;
    var change = opts.change || null;
    var animate = !opts.quiet;
    this.products.forEach(function (product) {
      self.paintCard(product, change && change.variant.product === product ? change : null);
    });
    this.paintTray(change);
    this.paintTotals(animate);
    this.paintRail(animate);
    this.paintCta();
    if (change) this.announce(change);
    try {
      document.dispatchEvent(new CustomEvent('rd-superset:change', { detail: { count: this.totals().count, items: this.items() } }));
    } catch (e) { /* old browsers */ }
  };

  Builder.prototype.items = function () {
    return Array.from(this.selection.entries()).map(function (entry) { return { id: Number(entry[0]), quantity: entry[1] }; });
  };

  Builder.prototype.paintCard = function (product, change) {
    var self = this;
    var card = this.cards.get(product.id);
    if (!card) return;
    var total = 0;
    product.colours.forEach(function (colour) {
      var n = 0;
      colour.variants.forEach(function (variant) { n += self.selection.get(variant.id) || 0; });
      total += n;
      var swatch = card.swatches[colour.index];
      var badge = swatch && swatch.querySelector('[data-n]');
      if (badge) {
        badge.hidden = !n;
        badge.textContent = n ? String(n) : '';
      }
      if (swatch) swatch.setAttribute('aria-label', colour.name + (n ? ', ' + n + ' picked' : ''));
    });
    card.el.classList.toggle('has-items', total > 0);
    if (card.count) {
      var before = card.count.textContent;
      card.count.hidden = !total;
      card.count.textContent = total ? '×' + total : '';
      if (change && total && before !== card.count.textContent) restart(card.count, 'is-pop');
    }

    Array.prototype.forEach.call(card.sizes.querySelectorAll('.rdss-size:not(.is-soldout)'), function (cell) {
      var variant = self.variants.get(cell.dataset.variantId);
      if (!variant) return;
      var qty = self.selection.get(variant.id) || 0;
      var addBtn = cell.querySelector('.rdss-size__add');
      var qtyEl = cell.querySelector('.rdss-size__qty');
      var minus = cell.querySelector('.rdss-size__minus');
      var label = self.variantLabel(variant);
      cell.classList.toggle('has-qty', qty > 0);
      cell.classList.toggle('is-2d', qty > 9);
      if (qtyEl) qtyEl.textContent = qty ? String(qty) : '';
      addBtn.setAttribute('aria-label', 'Add ' + label + (qty ? '. ' + qty + ' picked' : ''));
      if (minus) {
        if (qty) {
          minus.removeAttribute('tabindex');
          minus.removeAttribute('aria-hidden');
        } else {
          if (document.activeElement === minus) addBtn.focus({ preventScroll: true });
          minus.tabIndex = -1;
          minus.setAttribute('aria-hidden', 'true');
        }
      }
      if (change && change.variant.id === variant.id) restart(cell, 'is-pop');
    });
  };

  Builder.prototype.paintTray = function (change) {
    var self = this;
    if (!this.strip) return;
    var removedFocus = null;

    this.paintCartTray();

    this.trayItems.forEach(function (el, id) {
      if (self.selection.has(id)) return;
      self.trayItems.delete(id);
      if (el.contains(document.activeElement)) removedFocus = el;
      if (reduced() || !self.isOpen) {
        el.remove();
      } else {
        el.classList.add('is-out');
        el.setAttribute('aria-hidden', 'true');
        el.tabIndex = -1;
        window.setTimeout(function () { el.remove(); }, 230);
      }
    });

    this.selection.forEach(function (qty, id) {
      var variant = self.variants.get(id);
      if (!variant) return;
      var el = self.trayItems.get(id);
      var isNew = !el;
      if (isNew) {
        el = document.createElement('div');
        el.className = 'rdss-item';
        el.dataset.rdssItem = id;
        el.setAttribute('role', 'group');
        el.innerHTML = '<span class="rdss-item__pic">' +
            (variant.colour.thumb ? '<img src="' + esc(variant.colour.thumb) + '" alt="" width="64" height="64" decoding="async">' : '') +
          '</span>' +
          '<span class="rdss-item__info">' +
            '<span class="rdss-item__name">' + esc(variant.product.title) + '</span>' +
            '<span class="rdss-item__meta">' + (variant.colour.plain ? '' : esc(variant.colour.name) + ' \u00B7 ') + esc(variant.size) + '</span>' +
            '<span class="rdss-item__qty">' +
              '<button type="button" class="rdss-item__btn" data-rdss-minus="' + id + '" aria-label="Remove one">' + MINUS + '</button>' +
              '<span class="rdss-item__n" aria-live="off"></span>' +
              '<button type="button" class="rdss-item__btn" data-rdss-add="' + id + '" aria-label="Add one">' + PLUS + '</button>' +
            '</span>' +
          '</span>';
        self.strip.appendChild(el);
        self.trayItems.set(id, el);
      }
      var pill = el.querySelector('.rdss-item__n');
      pill.textContent = String(qty);
      el.setAttribute('aria-label', variant.product.title + ', ' + self.variantLabel(variant) + ', ' + qty + ' picked');
      if (change && change.variant.id === id) {
        if (isNew) {
          self.scrollStripTo(el);
        } else {
          restart(pill, 'is-pop');
        }
      }
    });

    this.root.classList.toggle('has-items', this.selection.size > 0);
    this.root.classList.toggle('has-cart-tops', this.cartLines.length > 0);
    if (this.stackN) this.stackN.textContent = tops(this.totals().total); // cart tops plus picks, as the discount counts them

    if (removedFocus) {
      var rest = Array.from(this.trayItems.values());
      var lastBtn = rest.length && rest[rest.length - 1].querySelector('[data-rdss-minus]');
      var target = lastBtn || this.cta;
      if (target) target.focus({ preventScroll: true });
    }
  };

  // The loose tops already in the cart, first in "Your stack". Each card can be changed or have one unit removed here.
  Builder.prototype.paintCartTray = function () {
    var self = this;
    if (!this.strip) return;
    var keep = {};
    this.cartLines.forEach(function (line) { keep[line.key] = true; });
    this.cartItems.forEach(function (el, key) {
      if (keep[key]) return;
      self.cartItems.delete(key);
      el.remove();
    });
    this.cartLines.forEach(function (line, i) {
      var el = self.cartItems.get(line.key);
      if (!el) {
        el = document.createElement('div');
        el.className = 'rdss-item rdss-item--cart is-quiet'; // not a pick: no drop-in
        el.setAttribute('role', 'group');
        el.dataset.rdssCartKey = line.key;
        var key = esc(line.key);
        // the quantity rides on the photo as a count badge (the same idiom as the colour swatches); the label sits where the minus and plus sit on a pick
        el.innerHTML = '<span class="rdss-item__pic">' +
            (line.thumb ? '<img src="' + esc(line.thumb) + '" alt="" width="64" height="64" decoding="async">' : '') +
            '<span class="rdss-item__badge" data-rdss-cart-n aria-hidden="true"></span>' +
          '</span>' +
          '<span class="rdss-item__info">' +
            '<span class="rdss-item__name">' + esc(line.title) + '</span>' +
            '<span class="rdss-item__meta">' + esc(line.meta) + '</span>' +
            '<span class="rdss-item__tag" data-rdss-cart-tag>In your cart</span>' +
            '<span class="rdss-item__acts">' +
              (line.variantId && self.variants.get(line.variantId) ?
                '<button type="button" class="rdss-item__chg" data-rdss-change="' + key + '" aria-expanded="false" data-rd-offer-interaction="cart_top_change">Change</button>' : '<span></span>') +
              '<button type="button" class="rdss-item__btn rdss-item__x" data-rdss-cart-remove="' + key + '" data-rd-offer-interaction="cart_top_remove" aria-label="' + esc('Remove ' + line.label + ' from your cart') + '">' + CROSS + '</button>' +
            '</span>' +
          '</span>' +
          '<div class="rdss-item__edit" data-rdss-edit hidden></div>' +
          '<p class="rdss-item__msg" data-rdss-cart-msg role="alert" hidden></p>';
        self.cartItems.set(line.key, el);
      }
      el.querySelector('[data-rdss-cart-n]').textContent = String(line.quantity);
      el.setAttribute('aria-label', line.label + ', ' + line.quantity + ' in your cart');
      var change = el.querySelector('[data-rdss-change]');
      if (change) change.setAttribute('aria-label', 'Change ' + (line.quantity > 1 ? 'one ' : '') + line.label);
      // cart cards sit before every pick, in cart order
      if (self.strip.children[i] !== el) self.strip.insertBefore(el, self.strip.children[i] || null);
    });
  };

  Builder.prototype.cartLineByKey = function (key) {
    return this.cartLines.filter(function (line) { return line.key === String(key); })[0] || null;
  };

  /* ---------- Change or remove a cart top from its card ---------- */

  Builder.prototype.cardMsg = function (key, text) {
    var el = this.cartItems.get(String(key));
    var msg = el && el.querySelector('[data-rdss-cart-msg]');
    if (!msg) { if (text) this.showMsg(text, 'error'); return; }
    msg.textContent = text || '';
    msg.hidden = !text;
  };

  Builder.prototype.setCardBusy = function (key, on) {
    var el = this.cartItems.get(String(key));
    this.root.classList.toggle('is-cart-busy', on);
    if (!el) return;
    el.classList.toggle('is-busy', on);
    if (on) el.setAttribute('aria-busy', 'true'); else el.removeAttribute('aria-busy');
    var tag = el.querySelector('[data-rdss-cart-tag]');
    if (tag) tag.textContent = on ? 'Updating' : 'In your cart';
  };

  Builder.prototype.closeEdit = function (exceptKey) {
    var self = this;
    this.cartItems.forEach(function (el, key) {
      if (key === exceptKey || !el.classList.contains('is-editing')) return;
      el.classList.remove('is-editing');
      var edit = el.querySelector('[data-rdss-edit]');
      if (edit) { edit.hidden = true; edit.innerHTML = ''; }
      var btn = el.querySelector('[data-rdss-change]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
      delete el._rdssEditColour;
    });
  };

  Builder.prototype.toggleEdit = function (key) {
    if (this.cartBusy) return;
    var el = this.cartItems.get(String(key));
    var line = this.cartLineByKey(key);
    if (!el || !line) return;
    var open = !el.classList.contains('is-editing');
    this.closeEdit(open ? String(key) : null);
    this.cardMsg(key, '');
    if (!open) return;
    delete el._rdssEditColour;
    el.classList.add('is-editing');
    var btn = el.querySelector('[data-rdss-change]');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    this.paintEdit(el, line);
    if (!this.calm) window.requestAnimationFrame(function () { el.scrollIntoView({ block: 'nearest' }); });
  };

  // The picker under a cart card: this product's colours, then the sizes of the colour on show.
  Builder.prototype.paintEdit = function (el, line) {
    var self = this;
    var variant = this.variants.get(line.variantId);
    var edit = el.querySelector('[data-rdss-edit]');
    if (!variant || !edit) return;
    var product = variant.product;
    var shown = typeof el._rdssEditColour === 'number' ? el._rdssEditColour : variant.colour.index;
    var colour = product.colours[shown] || variant.colour;
    var swatches = '';
    if (!(product.colours.length === 1 && product.colours[0].plain)) {
      swatches = '<div class="rdss-card__swatches" role="group" aria-label="Colour">' + product.colours.map(function (c) {
        return '<button type="button" class="rdss-swatch" data-rdss-edit-colour="' + c.index + '" aria-pressed="' + (c.index === colour.index) + '" aria-label="' + esc(c.name) + '" title="' + esc(c.name) + '">' +
          (c.thumb ? '<img src="' + esc(c.thumb) + '" alt="" width="52" height="52" decoding="async">' : '') + '</button>';
      }).join('') + '</div>';
    }
    var sizes = '<div class="rdss-card__sizes" role="group" aria-label="Size">' + colour.variants.map(function (v) {
      var current = v.id === variant.id;
      var label = esc(self.variantLabel(v));
      if (!current && !v.available) {
        return '<div class="rdss-size is-soldout"><button type="button" class="rdss-size__add" disabled aria-label="' + label + ', sold out"><span class="rdss-size__label">' + esc(v.size) + '</span></button></div>';
      }
      return '<div class="rdss-size' + (current ? ' is-current' : '') + '"><button type="button" class="rdss-size__add" data-rdss-edit-size="' + v.id + '" aria-pressed="' + current + '" aria-label="' + label + (current ? ', in your cart' : '') + '"><span class="rdss-size__label">' + esc(v.size) + '</span></button></div>';
    }).join('') + '</div>';
    var hint = '';
    if (colour.index !== variant.colour.index) {
      var same = colour.variants.filter(function (v) { return v.size === variant.size; })[0];
      hint = '<p class="rdss-item__hint">' + (same && !same.available ? esc(variant.size) + ' is sold out in ' + esc(colour.name) + '. ' : '') + 'Pick a size to swap.</p>';
    }
    edit.innerHTML = swatches + sizes + hint;
    edit.hidden = false;
  };

  Builder.prototype.editColour = function (key, index) {
    if (this.cartBusy) return;
    var el = this.cartItems.get(String(key));
    var line = this.cartLineByKey(key);
    var variant = line && this.variants.get(line.variantId);
    if (!el || !variant) return;
    var colour = variant.product.colours[index];
    if (!colour) return;
    if (colour.index === variant.colour.index) { delete el._rdssEditColour; this.paintEdit(el, line); return; }
    var same = colour.variants.filter(function (v) { return v.size === variant.size; })[0];
    if (same && same.available) { this.cartSwap(key, same.id); return; } // the same size in the new colour: apply at once
    el._rdssEditColour = colour.index; // that size is not there: show the colour's sizes and wait for a pick
    this.paintEdit(el, line);
  };

  // Runs one cart change for a card: busy state, then repaint the drawer and re-read the cart, or a short message and a re-sync.
  Builder.prototype.cartCall = function (key, run) {
    var self = this;
    if (this.cartBusy) return;
    this.cartBusy = true;
    this.cartToken += 1;
    this.clearMsg();
    this.cardMsg(key, '');
    this.closeEdit();
    this.setCardBusy(key, true);
    var finish = function () {
      self.cartBusy = false;
      self.root.classList.remove('is-cart-busy');
      self.cartItems.forEach(function (el, k) { self.setCardBusy(k, false); });
      if (!self.dialog.contains(document.activeElement) && self.panel) self.panel.focus({ preventScroll: true });
    };
    run().then(function (payload) {
      self.cartToken += 1;
      renderCartSections(payload);
      if (!self.applyCart(payload)) self.syncCart();
      finish();
      var t = self.totals();
      if (self.live) self.live.textContent = 'Cart updated. ' + tops(t.total) + ' in your stack.';
    }, function (error) {
      var text = cartErrorText(error);
      self.cartToken += 1;
      self.refreshCartNow().then(function () { return null; }, function () { return null; }).then(function () {
        finish();
        self.cardMsg(key, text);
      });
    });
  };

  function sameProps(a, b) {
    var ka = Object.keys(a || {}).sort();
    var kb = Object.keys(b || {}).sort();
    return ka.length === kb.length && ka.every(function (k, i) { return k === kb[i] && String(a[k]) === String(b[k]); });
  }

  // Line keys change every time the cart changes, so the key kept from an earlier read can be stale.
  // Read the cart again and find this line by its variant and properties; that gives the current key and quantity.
  Builder.prototype.freshLine = function (line) {
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    return request(cartUrl + '.js', { headers: { Accept: 'application/json' } }).then(function (cart) {
      var match = (cart.items || []).filter(function (item) {
        return !item.has_components && !item.parent_relationship && String(item.variant_id) === line.variantId && sameProps(item.properties, line.properties);
      })[0];
      if (!match) throw { description: 'That top is no longer in your cart.' };
      return match;
    });
  };

  Builder.prototype.changeLine = function (fresh) {
    return post(routeUrl('cart_change_url', '/cart/change'), { id: fresh.key, quantity: Math.max(0, fresh.quantity - 1), sections: sectionIds(), sections_url: sectionsPath() });
  };

  // One unit of this line becomes one unit of another variant of the same product.
  // Add first (keeping the line's properties), then take one off the old line: a failed add leaves the cart as it was.
  Builder.prototype.cartSwap = function (key, variantId) {
    var self = this;
    var line = this.cartLineByKey(key);
    var variant = this.variants.get(String(variantId));
    if (!line || !variant || this.cartBusy) return;
    if (String(line.variantId) === variant.id) { this.closeEdit(); return; }
    if (!variant.available) return;
    var item = { id: Number(variant.id), quantity: 1 };
    if (line.properties && Object.keys(line.properties).length) item.properties = line.properties;
    this.cartCall(key, function () {
      return post(routeUrl('cart_add_url', '/cart/add'), { items: [item] }).then(function () {
        return self.freshLine(line);
      }).then(function (fresh) { return self.changeLine(fresh); });
    });
  };

  // Takes one unit of this line out of the cart.
  Builder.prototype.cartRemove = function (key) {
    var self = this;
    var line = this.cartLineByKey(key);
    if (!line || this.cartBusy) return;
    this.cartCall(key, function () {
      return self.freshLine(line).then(function (fresh) { return self.changeLine(fresh); });
    });
  };

  Builder.prototype.scrollStripTo = function (el) {
    var strip = this.strip;
    if (this.calm) return;
    window.requestAnimationFrame(function () {
      el.scrollIntoView({ block: 'nearest' });
    });
  };

  Builder.prototype.tick = function (el, to, animate) {
    if (!el) return;
    if (el._rdssRaf) window.cancelAnimationFrame(el._rdssRaf);
    var from = typeof el._rdssValue === 'number' ? el._rdssValue : to;
    el._rdssValue = to;
    if (!animate || this.calm || reduced() || from === to) {
      el.textContent = money(to);
      return;
    }
    var start = null;
    var duration = 420;
    var step = function (now) {
      if (start === null) start = now;
      var t = Math.min(1, (now - start) / duration);
      var eased = 1 - Math.pow(1 - t, 3);
      var value = from + (to - from) * eased;
      el.textContent = t < 1 ? money(Math.round(value / 100) * 100) : money(to);
      if (t < 1) el._rdssRaf = window.requestAnimationFrame(step);
    };
    el._rdssRaf = window.requestAnimationFrame(step);
  };

  Builder.prototype.paintTotals = function (animate) {
    var t = this.totals();
    if (this.countEl) {
      var grew = t.count > (this.lastCount || 0);
      this.countEl.textContent = tops(t.count);
      if (animate && grew) restart(this.countEl, 'is-pop');
      this.lastCount = t.count;
    }
    if (this.wasEl) {
      this.wasEl.hidden = !t.off;
      this.wasEl.textContent = t.off ? money(t.full) : '';
    }
    if (this.saveEl) {
      this.saveEl.hidden = !t.off;
      this.saveEl.textContent = t.off ? 'Save ' + money(t.off) : '';
    }
    this.tick(this.nowEl, t.now, animate);
  };

  Builder.prototype.paintRail = function (animate) {
    var self = this;
    var t = this.totals();
    // fill = cart tops plus picks (counted once), capped at the last tier
    if (this.fillEl) this.fillEl.style.setProperty('--fill', String(this.barMax ? Math.min(t.total, this.barMax) / this.barMax : 0));
    (this.tickEls || []).forEach(function (el) {
      el.classList.toggle('is-reached', t.total >= Number(el.dataset.at));
    });
    (this.tierEls || []).forEach(function (el, i) {
      el.classList.toggle('is-reached', t.total >= self.tiers[i].qty);
      el.classList.toggle('is-current', i === t.tier);
      el.classList.toggle('is-next', !!t.next && t.next === self.tiers[i]);
    });
    this.lastTier = t.tier;

    var html = '';
    var current = t.tier > -1 ? this.tiers[t.tier] : null;
    if (t.cart) {
      // Tops already in the cart count towards the next tier (the stack below lists them): the line is only the call to action.
      if (t.next) {
        var short = t.next.qty - t.total;
        html = 'Add ' + short + ' more ' + (short === 1 ? 'top' : 'tops') + ' to save <b>' + money(t.next.off) + '</b>';
      } else if (current) {
        html = '<b>' + money(current.off) + ' off</b> \u00B7 max saving';
      }
    } else if (!current && t.next) {
      var need = t.next.qty - t.count;
      html = t.count === 0
        ? 'Pick ' + tops(t.next.qty) + ' to save <b>' + money(t.next.off) + '</b>'
        : 'Add ' + need + ' more ' + (need === 1 ? 'top' : 'tops') + ' to save <b>' + money(t.next.off) + '</b>';
    } else if (current && t.next) {
      var more = t.next.qty - t.count;
      html = '<b>' + money(current.off) + ' off</b> \u00B7 ' + more + ' more ' + (more === 1 ? 'top' : 'tops') + ' saves ' + money(t.next.off);
    } else if (current) {
      html = '<b>' + money(current.off) + ' off</b> \u00B7 max saving';
    }
    if (this.lineEl && html !== this.lineHtml) {
      this.lineHtml = html;
      this.lineEl.innerHTML = html;
      if (animate) restart(this.lineEl, 'is-swap');
    }
  };

  Builder.prototype.canCheckout = function () { return this.enabled || this.force; };

  Builder.prototype.paintCta = function () {
    if (!this.cta) return;
    var t = this.totals();
    var label;
    var price = '';
    var state = 'ready';
    if (this.added) { label = 'Added'; state = 'busy'; }
    else if (this.busy) { label = 'Adding'; state = 'busy'; }
    else if (!t.count) { label = 'Pick your tops'; state = 'empty'; }
    else if (!this.canCheckout()) { label = 'Superset opens at launch'; state = 'locked'; }
    else { label = 'Add ' + tops(t.count) + ' to cart'; price = money(t.now); }
    this.ctaLabel.textContent = label;
    this.ctaPrice.textContent = price;
    this.cta.classList.toggle('is-empty', state === 'empty');
    this.cta.classList.toggle('is-locked', state === 'locked');
    this.cta.classList.toggle('is-busy', state === 'busy');
    this.cta.setAttribute('aria-disabled', String(state !== 'ready' && state !== 'empty'));
    this.cta.setAttribute('aria-busy', String(state === 'busy'));
    if (state === 'ready') this.cta.setAttribute('aria-label', 'Add ' + tops(t.count) + ' to cart, ' + money(t.now) + (t.off ? ' after ' + money(t.off) + ' off' : ''));
    else this.cta.removeAttribute('aria-label');
  };

  Builder.prototype.announce = function (change) {
    var self = this;
    var t = this.totals();
    var variant = change.variant;
    var off = t.cart ? t.totalOff : t.off;
    var saving = off ? money(off) + ' off.' : (t.next ? 'Add ' + (t.next.qty - t.total) + ' more to save ' + money(t.next.off) + '.' : '');
    var text = (change.delta > 0 ? 'Added ' : 'Removed ') + variant.product.title + ', ' + this.variantLabel(variant) + '. ' + tops(t.count) + ' picked' + (t.cart ? ', ' + t.total + ' with your cart' : '') + '. ' + saving;
    window.clearTimeout(this.liveTimer);
    this.liveTimer = window.setTimeout(function () { if (self.live) self.live.textContent = text; }, 300);
  };

  Builder.prototype.showMsg = function (text, kind) {
    if (!this.msg) return;
    this.msg.textContent = text;
    this.msg.dataset.kind = kind || 'note';
    this.msg.hidden = false;
  };

  Builder.prototype.clearMsg = function () {
    if (!this.msg || this.msg.hidden) return;
    this.msg.hidden = true;
    this.msg.textContent = '';
  };

  /* ---------- Open and close ---------- */

  Builder.prototype.prime = function () {
    if (this.primed) return;
    this.primed = true;
    this.cards.forEach(function (card) {
      card.imgs.forEach(function (img) { if (img.classList.contains('is-on')) img.loading = 'eager'; });
    });
  };

  Builder.prototype.open = function (opts) {
    opts = opts || {};
    if (opts.force === true && isPreviewTheme()) this.force = true;
    if (!this.dialog) return;

    if (!this.isOpen) {
      var active = document.activeElement;
      this.opener = opts.opener || (active && active !== document.body ? active : null);
      this.syncCart();
      this.prime();
      this.isOpen = true;
      this.added = false;
      lockScroll();
      // Start from the closed (off-screen) state and let it render before sliding in.
      this.dialog.classList.remove('is-open');
      this.panel.style.transition = '';
      this.panel.style.transform = '';
      if (this.scrim) this.scrim.style.opacity = '';
      try {
        if (!this.dialog.open) this.dialog.showModal();
      } catch (e) {
        this.dialog.setAttribute('open', '');
      }
      if (this.scroller) this.scroller.scrollTop = 0;
      this.fit();
      void this.panel.getBoundingClientRect();
      var self = this;
      // Calm open: while the drawer slides in, the tops carried over from the page land without pops, flashes or count-ups
      this.calm = true;
      this.dialog.classList.add('is-calm');
      window.clearTimeout(this.calmTimer);
      this.calmTimer = window.setTimeout(function () {
        self.calm = false;
        if (!self.dialog) return;
        // tops carried over while opening keep still: no late drop-in once the drawer has landed
        Array.prototype.forEach.call(self.root.querySelectorAll('.rdss-item'), function (el) { el.classList.add('is-quiet'); });
        self.dialog.classList.remove('is-calm');
      }, 600);
      this.openToken = (this.openToken || 0) + 1;
      this.dialog.scrollLeft = 0;
      this.dialog.scrollTop = 0;
      this.dialog.classList.add('is-open');
      this.slide(true);
    }

    var variant = opts.variantId ? this.variants.get(String(opts.variantId)) : null;
    if (variant) {
      if (variant.product.active !== variant.colour.index) this.showColour(variant.product, variant.colour.index, false);
      this.carry(variant, opts.quantity);
    }
    var productId = opts.productId || (variant && variant.product.id);
    if (!variant && productId && typeof opts.colour === 'string') {
      var selectedProduct = this.products.find(function (item) { return String(item.id) === String(productId); });
      var selectedColour = selectedProduct && selectedProduct.colours.find(function (item) { return item.name === opts.colour; });
      if (selectedColour) this.showColour(selectedProduct, selectedColour.index, false);
    }
    if (!(productId && this.focusProduct(productId))) this.panel.focus({ preventScroll: true });
    this.paintCta();
  };

  // Square photos grow into any spare height so the cards fill the drawer instead of leaving a gap above the tray.
  Builder.prototype.fit = function () {
    return; // cards keep a fixed square photo
    var cards = this.cardsEl;
    var first = this.cards.get(this.products[0].id);
    var media = first && first.el.querySelector('.rdss-card__media');
    cards.style.removeProperty('--ss-media');
    if (!media) return;
    var room = this.scroller.clientHeight;
    var spare = room - cards.offsetHeight;
    if (spare < 8) return;
    var side = first.el.querySelector('.rdss-card__side');
    // Wide cards size their photo from the drawer width (the right column is fixed), so only narrow cards grow here.
    if (side && window.getComputedStyle(side).display !== 'contents') return;
    var base = media.offsetWidth;
    var max = Math.round(first.el.clientWidth * 0.56);
    var width = Math.min(max, base + Math.floor((spare - 4) / this.products.length));
    if (width <= base) return;
    cards.style.setProperty('--ss-media', width + 'px');
    if (cards.offsetHeight > room) cards.style.removeProperty('--ss-media');
  };

  Builder.prototype.focusProduct = function (productId) {
    var card = this.cards.get(String(productId));
    if (!card || !this.scroller) return false;
    var cardsPad = parseFloat(window.getComputedStyle(this.cardsEl).paddingTop) || 0;
    this.scroller.scrollTop = Math.max(0, card.el.offsetTop - cardsPad);
    card.el.focus({ preventScroll: true });
    restart(card.el, 'is-flash');
    return true;
  };

  Builder.prototype.close = function (opts) {
    opts = opts || {};
    if (!this.isOpen) return;
    var self = this;
    var opener = this.opener;
    var returnFocus = opts.returnFocus !== false;
    var finished = false;
    var timer = null;
    this.isOpen = false;
    this.opener = null;
    var fromTransform = window.getComputedStyle(this.panel).transform;
    this.panel.style.transform = '';
    if (this.scrim) this.scrim.style.opacity = '';
    this.dialog.classList.remove('is-open');

    var finish = function () {
      if (finished) return;
      finished = true;
      window.clearTimeout(timer);
      if (self.isOpen) { unlockScroll(); return; } // reopened while sliding out: keep the dialog
      self.closing = true;
      if (self.dialog.open) {
        try { self.dialog.close(); } catch (e) { self.dialog.removeAttribute('open'); }
      }
      self.closing = false;
      unlockScroll();
      if (returnFocus && opener && opener.isConnected && typeof opener.focus === 'function') opener.focus({ preventScroll: true });
      if (typeof opts.then === 'function') opts.then(opener);
    };
    // The slide out runs even with reduced motion: it shows where the panel goes.
    var anim = this.slide(false, fromTransform);
    if (anim) anim.onfinish = finish;
    timer = window.setTimeout(finish, 420);
  };

  /* Slide the drawer in or out like the size guide: one even ease, no overshoot.
     Driven by the Web Animations API; the CSS transition alone did not paint the movement. */
  Builder.prototype.slide = function (opening, fromTransform) {
    var off = phoneQuery.matches ? 'translate3d(0, 100%, 0)' : 'translate3d(100%, 0, 0)';
    var on = 'translate3d(0, 0, 0)';
    var duration = opening ? 360 : 300;
    var easing = 'cubic-bezier(0.4, 0, 0.2, 1)';
    if (this.panelAnim) this.panelAnim.cancel();
    if (this.scrimAnim) this.scrimAnim.cancel();
    this.panel.style.transition = 'none';
    if (this.scrim) this.scrim.style.transition = 'none';
    if (!this.panel.animate) return null;
    var start = opening ? off : (fromTransform && fromTransform !== 'none' ? fromTransform : on);
    this.panelAnim = this.panel.animate([{ transform: start }, { transform: opening ? on : off }], { duration: duration, easing: easing, fill: opening ? 'none' : 'forwards' });
    if (this.scrim) this.scrimAnim = this.scrim.animate([{ opacity: opening ? 0 : 1 }, { opacity: opening ? 1 : 0 }], { duration: duration, easing: 'ease', fill: opening ? 'none' : 'forwards' });
    var self = this;
    if (opening) {
      this.panelAnim.onfinish = function () {
        // hand back to CSS (drag to close on phones uses transitions)
        self.panel.style.transition = '';
        if (self.scrim) self.scrim.style.transition = '';
      };
    }
    return this.panelAnim;
  };

  /* ---------- Cart ---------- */

  // Turns one /cart.js line into a stack card entry. The builder's own photo and names are used when it knows the
  // variant; the cart line's own text and image stand in when it does not.
  Builder.prototype.cartLine = function (line, quantity) {
    var variant = this.variants.get(String(line.variant_id));
    var title;
    var meta;
    var thumb;
    var label;
    if (variant) {
      title = variant.product.title;
      meta = (variant.colour.plain ? '' : variant.colour.name + ' \u00B7 ') + variant.size;
      thumb = variant.colour.thumb;
      label = title + ' ' + (variant.colour.plain ? '' : variant.colour.name + ' ') + variant.size;
    } else {
      var parts = String(line.variant_title || '').split(' / ');
      var size = parts.length > 1 ? parts.pop() : '';
      var colourText = parts.join(' / ');
      title = line.product_title || line.title || '';
      meta = colourText && size ? colourText + ' \u00B7 ' + size : (colourText || size);
      if (/^default title$/i.test(meta)) meta = '';
      label = (title + ' ' + meta.replace(/ \u00B7 /g, ' ')).replace(/\s+$/, '');
    }
    if (!thumb) thumb = sized(line.image || (line.featured_image && line.featured_image.url), 180);
    return {
      key: String(line.key || line.id || line.variant_id),
      variantId: String(line.variant_id),
      quantity: quantity,
      title: title,
      meta: meta,
      label: label,
      thumb: thumb,
      properties: line.properties && typeof line.properties === 'object' ? line.properties : null
    };
  };

  // Takes the Superset tops out of a cart payload (lines of this builder's products, quantity included).
  // One pass sets the count that feeds the tier maths and the cards listed in the stack, so they always agree and the
  // tops are counted once. A Full Stack bundle line and its parts are skipped. Returns false when it is not a cart.
  Builder.prototype.applyCart = function (cart) {
    var self = this;
    if (!cart || !Array.isArray(cart.items)) return false;
    var ids = {};
    this.products.forEach(function (product) { ids[product.id] = true; });
    var count = 0;
    var lines = [];
    cart.items.forEach(function (line) {
      if (!line || line.parent_relationship || line.has_components) return;
      if (!ids[String(line.product_id)]) return;
      var quantity = Math.max(0, parseInt(line.quantity, 10) || 0);
      if (!quantity) return;
      count += quantity;
      lines.push(self.cartLine(line, quantity));
    });
    var sig = lines.map(function (line) { return line.key + ':' + line.variantId + ':' + line.quantity; }).join('|');
    if (count === this.cartTops && sig === this.cartSig) return true;
    this.cartTops = count;
    this.cartLines = lines;
    this.cartSig = sig;
    this.render({ quiet: true });
    return true;
  };

  // Reads the cart and takes the Superset tops already in it.
  Builder.prototype.syncCart = function () {
    var self = this;
    if (!window.fetch) return;
    var token = ++this.cartToken;
    var url = ((window.routes && window.routes.cart_url) || '/cart') + '.js';
    window.fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (response) {
      return response.ok ? response.json() : null;
    }).then(function (cart) {
      if (!cart || token !== self.cartToken) return;
      self.applyCart(cart);
    }).catch(function () { /* keep the last count */ });
  };

  // After a failed change: repaint the drawer from the server and re-read the cart for the sheet.
  // The sections request is a plain GET: with "Accept: application/json" Shopify answers /cart with the cart JSON, not sections.
  Builder.prototype.refreshCartNow = function () {
    var self = this;
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    return Promise.all([
      request(cartUrl + '.js', { headers: { Accept: 'application/json' } }),
      request(cartUrl + '?sections=' + sectionIds().join(',') + '&sections_url=' + encodeURIComponent(sectionsPath()), {}).catch(function () { return null; })
    ]).then(function (r) {
      var cart = r[0];
      if (r[1]) { cart.sections = r[1]; renderCartSections(cart); }
      self.cartToken += 1;
      self.applyCart(cart);
      return cart;
    });
  };

  // Keeps the count fresh when the cart changes on this page, so the next open is right from its first frame.
  Builder.prototype.watchCart = function () {
    var self = this;
    if (typeof window.subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    try {
      this.unwatchCart = window.subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        try { self.syncCart(); } catch (e) { /* never break the publisher */ }
      });
    } catch (e) { /* no pubsub: the open still reads the cart */ }
  };

  Builder.prototype.onCta = function () {
    var t = this.totals();
    if (this.busy || this.added) return;
    if (!t.count) {
      var firstCard = this.products.length ? this.cards.get(this.products[0].id) : null;
      var firstSize = firstCard && firstCard.sizes.querySelector('.rdss-size__add:not([disabled])');
      if (firstCard) {
        if (this.scroller) this.scroller.scrollTop = 0;
        restart(firstCard.el, 'is-nudge');
      }
      if (firstSize) firstSize.focus({ preventScroll: true });
      return;
    }
    if (!this.canCheckout()) {
      this.showMsg('Superset opens at launch. Your picks stay here till then.', 'note');
      return;
    }
    this.submit();
  };

  Builder.prototype.submit = function () {
    var self = this;
    var ds = this.root.dataset;
    var properties = {
      _rd_offer_id: ds.offerId || 'superset',
      _rd_offer_version: ds.offerVersion || 'v1',
      _rd_offer_placement: ds.offerPlacement || 'superset_builder'
    };
    var items = Array.from(this.selection.entries()).map(function (entry) {
      return { id: Number(entry[0]), quantity: entry[1], properties: properties };
    });
    var picked = this.totals().count;
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';

    this.busy = true;
    this.clearMsg();
    this.paintCta();

    window.fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: CART_SECTIONS, sections_url: window.location.pathname })
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (payload) {
        if (!response.ok || payload.status >= 400 || (payload.errors && !payload.items)) throw payload;
        return payload;
      });
    }).then(function (payload) {
      self.busy = false;
      self.added = true;
      self.paintCta();
      try {
        document.dispatchEvent(new CustomEvent('rd:offer-added', {
          detail: { offerId: properties._rd_offer_id, placement: properties._rd_offer_placement, offerType: 'bundle', operationId: uuid() }
        }));
      } catch (e) { /* analytics never blocks the cart */ }
      self.close({
        returnFocus: false,
        then: function (opener) {
          self.cartToken += 1; // a cart read still in flight predates this add
          self.cartTops += picked;
          self.selection.clear();
          self.save();
          self.added = false;
          self.render({ quiet: true });
          self.refreshCart(payload, opener);
        }
      });
    }).catch(function (error) {
      self.busy = false;
      self.paintCta();
      var text = error && (error.description || error.message);
      self.showMsg(typeof text === 'string' && text ? text : 'Couldn’t add your tops. Try again.', 'error');
    });
  };

  Builder.prototype.refreshCart = function (payload, opener) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) {
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      return;
    }
    try {
      if (opener && typeof drawer.setActiveElement === 'function') drawer.setActiveElement(opener);
      drawer.classList.remove('is-empty');
      if (payload && payload.sections && typeof drawer.renderContents === 'function') drawer.renderContents(payload);
    } catch (e) {
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      return;
    }
    if (typeof window.publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      window.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'rd-superset-builder', cartData: payload });
    }
    if (typeof drawer.open === 'function') drawer.open(opener || undefined);
  };

  /* ---------- Events ---------- */

  Builder.prototype.on = function (target, type, handler, options) {
    target.addEventListener(type, handler, options);
    this.handlers.push([target, type, handler, options]);
  };

  Builder.prototype.bind = function () {
    var self = this;
    if (!this.dialog) return;

    this.on(this.dialog, 'click', function (event) {
      if (event.target === self.scrim) { self.close(); return; }
      var button = event.target.closest && event.target.closest('button');
      if (!button || !self.dialog.contains(button)) return;
      if (button.hasAttribute('data-rdss-close')) { self.close(); return; }
      if (button.dataset.rdssChange) { self.toggleEdit(button.dataset.rdssChange); return; }
      if (button.dataset.rdssCartRemove) { self.cartRemove(button.dataset.rdssCartRemove); return; }
      if (button.dataset.rdssEditColour != null || button.dataset.rdssEditSize) {
        var holder = button.closest('.rdss-item--cart');
        var holderKey = holder && holder.dataset.rdssCartKey;
        if (button.dataset.rdssEditSize) self.cartSwap(holderKey, button.dataset.rdssEditSize);
        else self.editColour(holderKey, Number(button.dataset.rdssEditColour));
        return;
      }
      if (button.dataset.rdssAdd) { self.add(button.dataset.rdssAdd); return; }
      if (button.dataset.rdssMinus) { self.remove(button.dataset.rdssMinus); return; }
      if (button.dataset.rdssItem) { self.remove(button.dataset.rdssItem); return; }
      if (button.dataset.swatch != null) {
        var card = button.closest('.rdss-card');
        var product = card && self.products.filter(function (p) { return p.id === card.dataset.productId; })[0];
        var index = Number(button.dataset.swatch);
        if (product && index !== product.active) self.showColour(product, index, true);
        return;
      }
      if (button === self.cta) self.onCta();
    });

    this.on(this.dialog, 'keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        self.close();
      }
    });
    this.on(this.dialog, 'cancel', function (event) {
      event.preventDefault();
      self.close();
    });
    this.on(this.dialog, 'close', function () {
      if (self.closing || !self.isOpen) return;
      var opener = self.opener;
      self.isOpen = false;
      self.opener = null;
      self.dialog.classList.remove('is-open');
      unlockScroll();
      if (opener && opener.isConnected) opener.focus({ preventScroll: true });
    });

    this.bindDrag();

    var refit = function () { if (self.isOpen) self.fit(); };
    if (window.ResizeObserver && this.scroller) {
      this.resizer = new window.ResizeObserver(refit);
      this.resizer.observe(this.scroller);
    } else {
      this.on(window, 'resize', refit);
    }
  };

  Builder.prototype.bindDrag = function () {
    var self = this;
    var area = this.root.querySelector('[data-rdss-drag]');
    if (!area) return;
    var startY = 0;
    var lastY = 0;
    var lastT = 0;
    var speed = 0;
    var tracking = false;
    var moved = false;

    this.on(area, 'touchstart', function (event) {
      if (!phoneQuery.matches || !self.isOpen || event.touches.length !== 1) return;
      tracking = true;
      moved = false;
      startY = lastY = event.touches[0].clientY;
      lastT = event.timeStamp;
      speed = 0;
    }, { passive: true });

    this.on(area, 'touchmove', function (event) {
      if (!tracking) return;
      var y = event.touches[0].clientY;
      var dy = Math.max(0, y - startY);
      if (!moved && dy < 6) return;
      if (!moved) {
        moved = true;
        self.panel.style.transition = 'none';
        if (self.scrim) self.scrim.style.transition = 'none';
      }
      var dt = Math.max(1, event.timeStamp - lastT);
      speed = (y - lastY) / dt;
      lastY = y;
      lastT = event.timeStamp;
      self.panel.style.transform = 'translate3d(0,' + dy + 'px,0)';
      if (self.scrim) self.scrim.style.opacity = String(Math.max(0, 1 - dy / Math.max(1, self.panel.offsetHeight)));
    }, { passive: true });

    var end = function () {
      if (!tracking) return;
      tracking = false;
      if (!moved) return;
      var dy = Math.max(0, lastY - startY);
      self.panel.style.transition = '';
      if (self.scrim) self.scrim.style.transition = '';
      if (dy > 120 || (dy > 40 && speed > 0.5)) {
        self.close();
      } else {
        self.panel.style.transform = '';
        if (self.scrim) self.scrim.style.opacity = '';
      }
    };
    this.on(area, 'touchend', end);
    this.on(area, 'touchcancel', end);
  };

  Builder.prototype.destroy = function () {
    if (this.isOpen) {
      this.isOpen = false;
      try { this.dialog.close(); } catch (e) { /* already closed */ }
      unlockScroll();
    }
    if (this.resizer) this.resizer.disconnect();
    if (typeof this.unwatchCart === 'function') this.unwatchCart();
    this.handlers.forEach(function (h) { h[0].removeEventListener(h[1], h[2], h[3]); });
    this.handlers = [];
  };

  /* ---------- Page wiring ---------- */

  function scan(scope) {
    var node = scope || document;
    var roots = [];
    if (node.matches && node.matches('[data-rd-superset-builder]')) roots.push(node);
    if (node.querySelectorAll) roots = roots.concat(Array.prototype.slice.call(node.querySelectorAll('[data-rd-superset-builder]')));
    roots.forEach(function (root) {
      if (root.__rdss) return;
      root.__rdss = new Builder(root);
      instances.push(root.__rdss);
    });
  }

  function current() {
    instances = instances.filter(function (inst) { return inst.root.isConnected; });
    return instances[0] || null;
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest && event.target.closest(OPEN_SELECTOR);
    if (!opener) return;
    var inst = current();
    if (!inst) return;
    event.preventDefault();
    inst.open({ opener: opener, productId: opener.dataset.productId, variantId: opener.dataset.variantId, colour: opener.dataset.colour, quantity: opener.dataset.quantity });
  });

  var warm = function (event) {
    if (event.target.closest && event.target.closest(OPEN_SELECTOR)) {
      var inst = current();
      if (inst) inst.prime();
    }
  };
  document.addEventListener('pointerover', warm, { passive: true });
  document.addEventListener('focusin', warm);

  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    instances = instances.filter(function (inst) {
      if (event.target.contains(inst.root)) {
        inst.destroy();
        return false;
      }
      return true;
    });
  });

  window.RDSupersetBuilder = {
    version: 1,
    open: function (opts) {
      var inst = current();
      if (!inst) return false;
      inst.open(opts || {});
      return true;
    },
    close: function () {
      instances.forEach(function (inst) { inst.close(); });
    },
    items: function () {
      var inst = current();
      return inst ? inst.items() : [];
    },
    scan: scan
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); });
  else scan(document);
})();
